import { Table } from 'antd';
import { getAnnexData } from './annexData';

export const renderInstructionsContent = (
  pathname: string,
  t: (key: string) => string,
) => {
  const annexData = getAnnexData(t);

  if (pathname.includes('data_entry') || pathname.includes('data_management')) {
    return (
      <>
        <ul>
          <li>{t('INSTRUCTIONS.DATA_ENTRY_BRANCH_NOTE')}</li>
          <li>{t('INSTRUCTIONS.DATA_ENTRY_ICT_PROVIDER_NOTE')}</li>
          <li>{t('INSTRUCTIONS.DATA_ENTRY_MASTER_DATA_NOTE')}</li>
        </ul>

        <p>
          <strong>{t('INSTRUCTIONS.DATA_ENTRY_ANNEX_TITLE')}</strong>
        </p>

        <Table
          dataSource={annexData}
          pagination={false}
          rowKey={(_, index) => index as number}
          columns={[
            {
              title: t('INSTRUCTIONS.DATA_ENTRY_TABLE_TYPE_OF_ENTITY'),
              dataIndex: 'type',
              key: 'type',
            },
            {
              title: t('INSTRUCTIONS.DATA_ENTRY_TABLE_INSTRUCTION_COLUMN'),
              dataIndex: 'instruction',
              key: 'instruction',
              render: (text: string) => (
                <div dangerouslySetInnerHTML={{ __html: text }} />
              ),
            },
          ]}
        />
      </>
    );
  }

  if (pathname.includes('reporting')) {
    return (
      <p>
        {t('INSTRUCTIONS.REPORTING_TITLE')}
        <br />
        <strong>{t('INSTRUCTIONS.REPORTING_FORMAT')}</strong>
        <br />
        <br />
        {t('INSTRUCTIONS.REPORTING_C_CODE')}
        <br />
        {t('INSTRUCTIONS.REPORTING_DATE')}
        <br />
        {t('INSTRUCTIONS.REPORTING_REGISTER')}
      </p>
    );
  }

  return <p>{t('INSTRUCTIONS.WORKING_AREA_DEFAULT_NOTE')}</p>;
};
